import { useState } from "react";
import { MoveHorizontal } from "lucide-react";

export const CompareSlider = ({ product }) => {
  const [pos, setPos] = useState(50);
  const [light, dark] = product.finishes;
  return (
    <div className="relative aspect-[4/5] w-full select-none overflow-hidden rounded-sm md:aspect-[5/4]" data-testid="compare-slider">
      <img src={light.image} alt={`${product.name} in ${light.name}`} className="absolute inset-0 h-full w-full object-cover" />
      <img
        src={dark.image}
        alt={`${product.name} in ${dark.name}`}
        className="absolute inset-0 h-full w-full object-cover"
        style={{ clipPath: `inset(0 0 0 ${pos}%)` }}
      />
      <div className="pointer-events-none absolute inset-y-0 w-px bg-white" style={{ left: `${pos}%` }}>
        <span className="absolute left-1/2 top-1/2 grid h-14 w-14 -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full bg-bone text-ink shadow-xl">
          <MoveHorizontal className="h-5 w-5" />
        </span>
      </div>
      <span className="absolute bottom-4 left-4 rounded-full bg-bone/90 px-3 py-1.5 text-[11px] uppercase tracking-[0.14em] backdrop-blur">Light</span>
      <span className="absolute bottom-4 right-4 rounded-full bg-ink/80 px-3 py-1.5 text-[11px] uppercase tracking-[0.14em] text-bone backdrop-blur">Dark</span>
      <input
        type="range"
        min="0"
        max="100"
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        aria-label="Compare finishes"
        data-testid="compare-slider-input"
        className="absolute inset-0 h-full w-full cursor-ew-resize opacity-0"
      />
    </div>
  );
};
